/** @jsx jsx */
import React, { useState } from 'react';

import SelectForm from 'components/molecules/SelectForm';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import FormLabel from 'components/atoms/Form/FormLabel';
import FlexBox from 'components/atoms/FlexBox';
import productColor, {
} from 'components/styles';
import DataTable from 'components/organismos/DataTable/DataTable';
import { css, jsx } from '@emotion/core';
import Accordion from 'components/molecules/Accordion';
import SpecialHolidayDigestionDomain from 'domain/master/holidayManagement/specialHolidayDigestion';
import { Column } from 'react-table';
import Modal from 'components/molecules/Modal';
import moment from 'moment';

import IconLabelButton from 'components/molecules/IconLabelButton';
import CalendarForm from 'components/molecules/CalendarForm';
import VerticalLabelTextLayout from 'components/atoms/Form/VerticalLabelTextLayout';
import { isSafari, isIPad13, isTablet } from 'react-device-detect';
import { useAcquisitionStatusDomainForm, useDownloadHolidayManagementAcquisitionStatus } from './hooks';
import BlockUI from 'components/molecules/BlockUi';
import FormPadding from 'components/atoms/Form/FormPadding';
import Calendar from 'components/molecules/CalendarV1';
import TextTooltip from 'components/molecules/TextTooltip';

// create style form
const styles = {
  form: css({
    paddingTop: '15px',
  }),
  wrapper: css({
    display: 'flex',
    width: '150px',
    float: 'left',
  }),
  container: css({
    padding: '4px 0',
  }),
  label: css({
    flexBasis: '100px',
  }),
  select: css({
    flexGrow: 4,
    minWidth: '100px',
  }),
  detail: css({
    backgroundColor: 'transparent',
    borderRadius: '5px',
    textAlign: 'center',
    marginLeft: '5px',
  }),
  detailButton: css({
    padding: '4px',
    color: productColor.primary,
    fontSize: '12px'
  }),
  selectDay: css({
    minWidth: '100px',
    width: '170px',
  }),
  input: css({
    maxWidth: '600px',
    padding: '30px',
    marginBottom: '30px',
  }),
  wrapAccordion: css({
    backgroundColor: '#fff'
  }),
  center: css({
    textAlign: 'center',
    justifyContent: 'center',
  }),
  globalSearch: css({
    marginLeft: '30px',
    marginBottom: '10px'
  }),
  backgroundWhite: css({
    backgroundColor: '#fff',
  }),
  table: css({
    color: '#666666',
  }, css`
    table.table-bordered tr td,
    table.table-bordered tr th{
      border:1px solid #dcdcdc;
      text-align:center
    } 
  `),
  customStyle: css({
    display: 'flex',
    justifyContent: ((isSafari && isTablet) || isIPad13) ? 'flex-start' : 'flex-end',
    paddingRight: ((isSafari && isTablet) || isIPad13) ? '10px' : '30px',
    marginBottom: ((isSafari && isTablet) || isIPad13) ? '0px' : '-55px',
  }, css`
    button{
      width:auto;
      margin-left:15px
    }
    button:hover{
      background:transparent
    }
    button svg{
      width:20px !important;
      height:20px !important;
    }
  `),
  note: css({
    paddingLeft: '5px',
    fontSize: '14px',
    color: '#666666',
    position: 'relative'
  })
};

export interface DataDetail {
  staffCode: string,
  staffName: string,
  holidayName: string
}

const AcquisitionStatusForm: React.FC<
  {
    orgTreesOptions: any,
    currentAccordionList: any,
    setCurrentAccordionList: any
  }> = ({
    orgTreesOptions,
    currentAccordionList,
    setCurrentAccordionList,
  }) => {
    const {
      paidHolidayDigestedtHistoryList,
      callGetAcquisitionStatusDetail,
      orgCode,
      setOrgCode,
      searchDate,
      setSearchDate,
      modalOpen,
      setModalOpen,
      closeModal,
      detailItems,
    } = useAcquisitionStatusDomainForm();

    const {
      downloadHolidayManagementAcquisitionStatus, blocking
    } = useDownloadHolidayManagementAcquisitionStatus(
      orgCode,
      searchDate,
    );

    //
    const [dataDetail, setDataDetail] = useState<DataDetail>({
      staffCode: '',
      staffName: '',
      holidayName: '',
    });

    // handlePaidHolidayStatusDetail
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleTransferHolidayStatusDetail = async (data: any) => {
      setDataDetail(data);
      callGetAcquisitionStatusDetail(data.staffCode);
      setModalOpen(true);
    };

    //
    const columns: Array<Column<SpecialHolidayDigestionDomain>> = React.useMemo(() => [
      {
        Header: () => 'スタッフコード',
        id: 'staffCode',
        accessor: 'staffCode',
        Cell: (cell: {
          row: { isExpanded: boolean, original: SpecialHolidayDigestionDomain },
          data: Array<SpecialHolidayDigestionDomain>
        }) => (
            <FlexBox>
              <TextTooltip 
              text={cell.row.original.staffCode}
              textDis={(
                <span>{cell.row.original.staffCode}</span>
              )}
              customCss={css({
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxWidth: '155px',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                margin: '0px auto',
              })}
              />
              {/* <div css={css(styles.detail)}>
                <ClickableIconButton
                  onClick={() => handleTransferHolidayStatusDetail(cell.row.original)}
                  additionalCss={styles.detailButton}
                >
                  詳細
              </ClickableIconButton>
              </div> */}
              <IconLabelButton
                onClick={() => handleTransferHolidayStatusDetail(cell.row.original)}
                text="詳細"
                isIcon={false}
              />
            </FlexBox>
          ),
      },
      {
        Header: 'スタッフ名',
        accessor: 'staffName',
      },
      {
        Header: '休暇名',
        accessor: 'holidayName',
      },
      {
        Header: '合計',
        accessor: 'totalStr',
        Cell: (cell: { row: { isExpanded: boolean, original: any } }) => (
          <div style={{ textAlign: 'center' }}>
            {cell.row.original.totalStr}
          </div>
        ),
      },
    ], [handleTransferHolidayStatusDetail]);

    //
    return (
      <BlockUI blocking={blocking}>
        <Accordion
          text="取得状況"
          callBack={() => { }}
          defaultExpand={(currentAccordionList.indexOf('SPECIAL_AS') !== -1)}
        >
          <div css={styles.backgroundWhite}>
            {/* <FormContentFilter> */}
            <FormPadding customStyle={css({ paddingTop:'16px',paddingLeft:'10px', paddingRight:'10px', maxWidth:'580px'})}>
                <FlexBox>
                  <div css={styles.label}>
                    <FormLabel
                      label="対象期間"
                    />
                  </div>
                  <div css={styles.selectDay}>
                    {/* <CalendarForm required={true} label="" date={new Date(searchDate)} dateFormat="YYYY年MM月DD日" changeDate={(date: Date) => setSearchDate(date)} /> */}
                    <Calendar 
                    date={new Date(searchDate)}
                    setDate={(date) => {
                      if(date){
                        setSearchDate(date)
                      }
                    }}
                    />
                  </div>
                  <div css={styles.note}>から過去1年間 </div>
                </FlexBox>
            </FormPadding>
            <FormPadding customStyle={css({paddingLeft:'10px', paddingRight:'10px', maxWidth:'580px'})}>
            <SelectForm
                label="組織"
                name="orgCode003"
                value={String(orgCode)}
                setValue={(val: string) => setOrgCode(val)}
                options={orgTreesOptions}
              />
            </FormPadding>
            {/* </FormContentFilter> */}
            <div
              css={css`
              table th:nth-of-type(1) {
                width: 200px;
              }
              table th:nth-of-type(2) {
                width: 200px;
              }
              table th:nth-of-type(3) {
                width: 200px;
              }
              table th:nth-of-type(4) {
                width: 80px;
              }
            `}
            >
              <FormSubmitArea customStyle={styles.customStyle}>
                <IconLabelButton onClick={() => downloadHolidayManagementAcquisitionStatus()} iconType="download" text="ダウンロード" />
                {/* <IconLabelButton onClick={() => downloadHolidayManagementAcquisitionStatus(true)} iconType="download" text="全組織ダウンロード" /> */}
              </FormSubmitArea>
              <div className="table-bordered" style={{ overflowX: 'auto', whiteSpace: 'nowrap', marginTop: '10px', padding:'0 10px 10px' }}>
                <DataTable
                  classNameParrant="border-left-right"
                  className="table-no-border-left-right"
                  columns={columns}
                  data={paidHolidayDigestedtHistoryList}
                  isGlobalFilter={true}
                  minWidth="704px"
                  // globalSearchStyle={styles.globalSearch}
                />
              </div>
            </div>
            {/* Form Detail */}
            <Modal
              open={modalOpen}
              closeHandler={closeModal}
              title="取得状況詳細"
              submitText=""
              onSubmit={closeModal}
              closeText="閉じる"
            >
              <div style={{ width: '350px', margin: '0 auto', fontSize: '14px' }} css={styles.table}>

                <VerticalLabelTextLayout
                  label="スタッフコード"
                  variable={dataDetail.staffCode}
                />
                <VerticalLabelTextLayout
                  label="スタッフ名"
                  variable={dataDetail.staffName}
                />

                <VerticalLabelTextLayout
                  label="期間"
                  variable={`${moment(detailItems.fromDate).format('YYYY年MM月DD日')}～${moment(detailItems.toDate).format('YYYY年MM月DD日')}`}
                />
                <VerticalLabelTextLayout
                  label="休暇名"
                  variable={dataDetail.holidayName}
                />

                <table className="table-bordered" style={{ width: '100%', fontSize: '14px' }}>
                  <thead>
                    <tr>
                      <th>日付</th>
                      <th>消化日数</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailItems.specialHolidayDigestionDetailList
                      && detailItems.specialHolidayDigestionDetailList.map((item: any, index: number) => (
                        <tr key={index}>
                          <td>{moment(item.targetDate).format('YYYY年MM月DD日')}</td>
                          <td>{item.digestionDaysNum} 日</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </Modal>
          </div>
        </Accordion>
      </BlockUI>
    );
  };
export default AcquisitionStatusForm;
